import { getFormattedValue } from "../../lib/utils.js";
import { MSDropdown } from '../common/dropdown/index.js';
import { makeid } from '../common/utils/idgen.js';
import styles from './timeinterval.css'

const startArrowIcon = '<svg class="timeinterval-start icon-arrow" id="timeinterval-start" xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12"><path d="M13.29 11.29C13.68 10.9 13.68 10.27 13.29 9.87998L9.41998 5.99998L13.3 2.11998C13.69 1.72998 13.69 1.09998 13.3 0.70998C12.91 0.31998 12.28 0.31998 11.89 0.70998L7.29998 5.29998C6.90998 5.68998 6.90998 6.31998 7.29998 6.70998L11.89 11.3C12.27 11.68 12.9 11.68 13.29 11.29Z"/><path d="M6.69998 11.29C7.08998 10.9 7.08998 10.27 6.69998 9.87998L2.82998 5.99998L6.70998 2.11998C7.09998 1.72998 7.09998 1.09998 6.70998 0.70998C6.31998 0.31998 5.68998 0.31998 5.29998 0.70998L0.70998 5.29998C0.31998 5.68998 0.31998 6.31998 0.70998 6.70998L5.29998 11.3C5.67998 11.68 6.30998 11.68 6.69998 11.29Z"/></svg>';
const leftArrowIcon = '<svg class="timeinterval-back icon-arrow" id="timeinterval-back" xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12"><path d="M6.70998 9.87998L2.82998 5.99998L6.70998 2.11998C7.09998 1.72998 7.09998 1.09998 6.70998 0.70998C6.31998 0.31998 5.68998 0.31998 5.29998 0.70998L0.70998 5.29998C0.31998 5.68998 0.31998 6.31998 0.70998 6.70998L5.29998 11.3C5.68998 11.69 6.31998 11.69 6.70998 11.3C7.08998 10.91 7.09998 10.27 6.70998 9.87998Z"/></svg>';
const rightArrowIcon = '<svg class="timeinterval-forward icon-arrow" id="timeinterval-forward" xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12"><path d="M1.29006 9.87998L5.17006 5.99998L1.29006 2.11998C0.900059 1.72998 0.900059 1.09998 1.29006 0.70998C1.68006 0.31998 2.31006 0.31998 2.70006 0.70998L7.29006 5.29998C7.68006 5.68998 7.68006 6.31998 7.29006 6.70998L2.70006 11.3C2.31006 11.69 1.68006 11.69 1.29006 11.3C0.910059 10.91 0.900059 10.27 1.29006 9.87998Z"/></svg>';
const endArrowIcon = '<svg class="timeinterval-end icon-arrow" id="timeinterval-end" xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12"><path d="M0.700215 0.710011C0.310215 1.10001 0.310215 1.73001 0.700215 2.12001L4.58021 6.00001L0.700215 9.88001C0.310215 10.27 0.310215 10.9 0.700215 11.29C1.09021 11.68 1.72022 11.68 2.11022 11.29L6.70021 6.70001C7.09021 6.31001 7.09021 5.68001 6.70021 5.29001L2.12021 0.710011C1.73021 0.320011 1.09021 0.320011 0.700215 0.710011Z"/><path d="M7.29021 0.710022C6.90021 1.10002 6.90021 1.73002 7.29021 2.12002L11.1702 6.00002L7.29021 9.88002C6.90021 10.27 6.90021 10.9 7.29021 11.29C7.68021 11.68 8.31021 11.68 8.70021 11.29L13.2902 6.70002C13.6802 6.31002 13.6802 5.68002 13.2902 5.29002L8.70021 0.700022C8.32021 0.320022 7.68021 0.320022 7.29021 0.710022Z"/></svg>';
const iconDropdown = '<svg width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 0H0V1H1V2H2V3H3V4H5V3H6V2H7V1H8V0Z" fill="black"/></svg>'

const locale = {
    days: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
    daysShort: ['Вос', 'Пон', 'Вто', 'Сре', 'Чет', 'Пят', 'Суб'],
    daysMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
    monthsShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
    today: 'Сегодня',
    clear: 'Очистить',
    dateFormat: 'dd.MM.yyyy',
    timeFormat: 'HH:mm',
    firstDay: 1
};

const periods = () => {
    return {
        mil: { label: `${i18next.t('interval_short_millisecond')}`, ms: 1 },
        sec: { label: `${i18next.t('interval_short_second')}`, ms: 1000 },
        min: { label: `${i18next.t('interval_short_minute')}`, ms: 1000 * 60 },
        hou: { label: `${i18next.t('interval_short_hour')}`, ms: 60 * 60 * 1000 },
        day: { label: `${i18next.t('interval_short_day')}`, ms: 24 * 60 * 60 * 1000 },
        mon: { label: `${i18next.t('interval_short_month')}`, ms: 30 * 24 * 60 * 60 * 1000 },
        yea: { label: `${i18next.t('interval_short_year')}`, ms: 365 * 24 * 60 * 60 * 1000 },
    }
}

const selectDefault = () => [
    { id: 'create', component: `${i18next.t('trend_timeInterval_create')}`, active: true, default: true },
    { id: 'sort', component: `${i18next.t('trend_timeInterval_sort')}`, active: true, default: true },
    { id: 'all', component: `${i18next.t('trend_timeInterval_all')}`, active: true, default: true },
    { id: 'day', component: `${i18next.t('trend_timeInterval_select_day')}`, value: 1000 * 60 * 60 * 24, active: true, default: true, state: { value: 1, select: 'day' } },
]


const getCorrectTime = (total) => {
    const result = []
    let timeArr = ['yea', 'mon', 'day', 'hou', 'min', 'sec', 'mil']
    for (let i = 0; i < timeArr.length; i++) {
        const step = periods()[timeArr[i]]
        const stepResult = getTime(total, step.ms)
        if (stepResult) {
            result.push(`${stepResult} ${step.label}`)
            total -= stepResult * step.ms
        }
    }
    return result.join(' ')
}

const getTime = (total, ms) => Math.floor(total / ms >= 1 ? total / ms : 0)

const createDateString = (date) => getFormattedValue("dd.MM.yyyy HH:mm:ss", new Date(date))

const menuTreeTemplate = (value = 'min') => `
    <div class="tree-control-wrap" id="tree-control-wrap">
        <input id="tree-control-input" type="text" value="1" />
        <select id="tree-control-select" name="Значение" value="${value}">
            <option value="mil" ${value === 'mil' ? 'selected' : ''} >${i18next.t('interval_millisecond')}</option>
            <option value="sec" ${value === 'sec' ? 'selected' : ''} >${i18next.t('interval_second')}</option>
            <option value="min" ${value === 'min' ? 'selected' : ''} >${i18next.t('interval_minute')}</option>
            <option value="hou" ${value === 'hou' ? 'selected' : ''} >${i18next.t('interval_hour')}</option>
            <option value="day" ${value === 'day' ? 'selected' : ''} >${i18next.t('interval_day')}</option>
            <option value="mon" ${value === 'mon' ? 'selected' : ''} >${i18next.t('interval_month')}</option>
            <option value="yea" ${value === 'yea' ? 'selected' : ''} >${i18next.t('interval_year')}</option>
        </select>
        <div id="tree-control-btn" class="timeinterval-btn-delete">${i18next.t('delete')}</div>
    </div>
`

const timeTemplate = (date) => `
    <div id="value">${createDateString(date)}</div>
    <div class="timer-interval-icon"></div>
    <input class="hidden input-calendar" type="text" />
`

const dropdownLabelTemplate = (value) => `
    <div class="timeinterval-label" id="timeinterval-label">${value}</div>
    <svg class="icon-dropdown" width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 0H0V1H1V2H2V3H3V4H5V3H6V2H7V1H8V0Z" fill="black"/>
    </svg>
`

const rowTemplate = (date) => {
    const t = getCorrectTime(date)
    return `
        <div class="time-element"><div id="value">${t}</div><div class="icon-dropdown icon-rotate"></div></div>
    `
}
const dropdownTemplate = `
    <ui-dropdown drop-position="top" id="timeinterval-dropdown" border="1">
        <div slot="label" id="interval-dropdown-label" class="interval-dropdown-label"></div>
        <div class="dropdown-btn dropdown-up-btn" id="dropdown-up-btn" slot="childrens">
            <svg width="8" height="12" viewBox="0 0 8 12" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.70998 9.87998L2.82998 5.99998L6.70998 2.11998C7.09998 1.72998 7.09998 1.09998 6.70998 0.70998C6.31998 0.31998 5.68998 0.31998 5.29998 0.70998L0.70998 5.29998C0.31998 5.68998 0.31998 6.31998 0.70998 6.70998L5.29998 11.3C5.68998 11.69 6.31998 11.69 6.70998 11.3C7.08998 10.91 7.09998 10.27 6.70998 9.87998Z"/>
            </svg>
        </div>
        <div class="dropdown-btn dropdown-down-btn" id="dropdown-down-btn" slot="childrens">
            <svg width="8" height="12" viewBox="0 0 8 12" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.70998 9.87998L2.82998 5.99998L6.70998 2.11998C7.09998 1.72998 7.09998 1.09998 6.70998 0.70998C6.31998 0.31998 5.68998 0.31998 5.29998 0.70998L0.70998 5.29998C0.31998 5.68998 0.31998 6.31998 0.70998 6.70998L5.29998 11.3C5.68998 11.69 6.31998 11.69 6.70998 11.3C7.08998 10.91 7.09998 10.27 6.70998 9.87998Z"/>
            </svg>
        </div>
    </ui-dropdown>
`

const template = `
    <style>
       ${styles}
    </style>
    <div id="time-interval-container" class="time-interval-container">
        <div id="time-interval-start" class="timer-interval"></div>
        <div class="interval-controller">
            ${startArrowIcon}
            ${leftArrowIcon}
            <div class="timeinterval-select" id="timeinterval-select">${dropdownTemplate}</div>
            ${rightArrowIcon}
            ${endArrowIcon}
        </div>
        <div id="time-interval-end" class="timer-interval"></div>
    </div>
`

/**
 * @class TimeInterval
 * @classdesc Временной интервал
 * */
export class TimeInterval {
    constructor(root, container) {
        this.root = root
        this.container = container
        this.container.innerHTML = template
        this._intervalChanged = false
        this.initDropdown()
        this.init()
        this.render()
    }

    init() {
        this.labelElem = this.container.querySelector('#interval-dropdown-label')
        const startElem = this.root.shadowRoot.getElementById('time-interval-start')
        startElem.innerHTML = timeTemplate(this.startDate)
        this.startInputElem = startElem.querySelector('input')
        this.startLabelElem = startElem.querySelector('#value')
        const endElem = this.root.shadowRoot.getElementById('time-interval-end')
        endElem.innerHTML = timeTemplate(this.endDate)
        this.endInputElem = endElem.querySelector('input')
        this.endLabelElem = endElem.querySelector('#value')
        this._endDate = new Date()
        this._startDate = new Date()
        this.selectValues = selectDefault()
        if(this.root.interval){
            this.select = { value: this.root.interval, id: null, update: true, curValue: this.root.interval}
        } else {
            this.select = { value: 1000 * 60 * 60 * 24, id: 'day', update: true, curValue: 1000 * 60 * 60 * 24 }
        }
        this.initDatepicker()
    }

    initDatepicker() {
        const { options } = {
            options: {
                view: "days",
                timepicker: true,
                buttons: [ {
                    content(dp) {
                        return `<div class="tooltip-wrap"><div class="main-pen-icon">${i18next.t('trend_timeInterval_today')}</div><div class="tooltip">${i18next.t('trend_timeInterval_today_tooltip')}</div></div>`;
                    },
                    onClick(dp) {
                        dp.selectDate(new Date(), {updateTime: true})
                    }
                }]
            }
        }
        const opt = { ...options, locale, autoClose: false,};

        const changeOpen = (elem, value) => {
            if(!value) this.setDateEvent(elem, elem === "start" ? +this.dpStart.selectedDates[0] : +this.dpEnd.selectedDates[0])
            if(elem === 'start') this.isTimeStartOpen = value
            if(elem === 'end')this.isTimeEndOpen = value
        }

        const optStart = {
            ...opt,
            onShow(isFinished){
                if(isFinished) changeOpen('start', true)
            },
            onHide(isFinished){
                if(isFinished) changeOpen('start', false)
            },
            position: 'top left',
            selectedDates: [this.startDate]
        }

        const optEnd = {
            ...opt,
            onShow(isFinished){
                if(isFinished) changeOpen('end', true)
            },
            onHide(isFinished){
                if(isFinished) changeOpen('end', false)
            },
            position: 'top right',
            selectedDates: [this.endDate]
        }
        this.dpStart = new AirDatepicker(this.startInputElem , optStart);
        this.dpEnd = new AirDatepicker(this.endInputElem, optEnd);
        this.dpStart.init();
        this.dpEnd.init();
    }

    initDropdown() {
        this.root.checkComponent('ui-dropdown', MSDropdown)
        this.dropdown = this.container.querySelector('#timeinterval-dropdown')
        this.dropdown.onActive = this.toggleDropdown.bind(this)
        this.dropdown.cssElem.innerHTML += styles
        this.dropdownDownBtnElem = this.container.querySelector('#dropdown-down-btn')
        this.dropdownUpBtnElem = this.container.querySelector('#dropdown-up-btn')
        this.dropdown.onClick = this.onClick.bind(this)
        this.dropdown.listElem.addEventListener('mousemove', this.onMenuSelect.bind(this))
        this.initMenu()
    }

    initMenu() {
        this.dropdownMemu = menuTreeTemplate()
        this.dropdownContainer = document.createElement('div')
        this.dropdownContainer.setAttribute('class', 'float-container')
        this.dropdown.childrens.appendChild(this.dropdownContainer)
        this.dropdownContainer.innerHTML = this.dropdownMemu
        this.dropdownContainer.style.display = 'none'
        this.dropdownContainer.addEventListener('click', (e) => e.stopPropagation())
        this.dropdownMemuInput = this.dropdown.shadowRoot.querySelector('#tree-control-input')
        this.dropdownMemuSelect = this.dropdown.shadowRoot.querySelector('#tree-control-select')
        this.dropdownMemuBtn = this.dropdown.shadowRoot.querySelector('#tree-control-btn')
        this.dropdownMemuInput.addEventListener('keyup', this.onInput.bind(this))
        this.dropdownMemuSelect.addEventListener('change', this.onSelect.bind(this))
        this.dropdownMemuBtn.addEventListener('click', this.onDelete.bind(this))
    }

    render() {
        const btnStart = this.container.querySelector('#timeinterval-start')
        const btnEnd = this.container.querySelector('#timeinterval-end')
        const btnBack = this.container.querySelector('#timeinterval-back')
        const btnForward = this.container.querySelector('#timeinterval-forward')
        btnBack.addEventListener('click', this.root.PreviousPage.bind(this.root))
        btnForward.addEventListener('click', this.root.NextPage.bind(this.root))
        btnStart.addEventListener('click', this.root.FirstPage.bind(this.root))
        btnEnd.addEventListener('click', this.root.LastPage.bind(this.root))
        this.labelElem.innerHTML = dropdownLabelTemplate('1 день')
        this.dropdown.createList()
    }

    createRow() {
        const component = this.createRowComponent()
        const row = {
            id: makeid(12),
            component,
            value: 1000 * 60,
            active: true,
            default: false,
            state: { value: 1, select: 'min' }
        }
        this.selectValues.splice(3, 0, row)
        this.dropdown.createList()
    }

    createRowComponent(timestamp = 60000) {
        const template = rowTemplate(timestamp)
        const component = document.createElement('div')
        component.innerHTML = template
        return component
    }

    saveIntervalState() {
        const timeIntervals = this.selectValues.filter(int => !int.default)
        this.root.saveItemState({ timeIntervals: timeIntervals })
    }

    setDefaultState() {
        const storedState = $ss.getItemState(this.root.originPath);
        const intervals = storedState.timeIntervals
            .map(int => ({ ...int, component: this.createRowComponent(int.value) }))
        this.selectValues = [...selectDefault(), ...intervals]
    }

    onMenuSelect(e) {
        const li = e.target.closest('li')
        const Id = li?.getAttribute('Id')
        if (!li || !Id) return
        const defaults = ['create', 'sort', 'all', 'day']
        const item = this.selectValues.find(item => item.id === Id)
        if (!item || defaults.includes(item.id)) return this.dropdownContainer.style.display = 'none'
        this.dropdownContainer.style.display = 'block'
        this.dropdownContainer.style.top = li.offsetTop - this.dropdown.listElem.scrollTop
        this.selectedRaw = item
        this.dropdownMemuInput.value = item.state.value
        this.dropdownMemuSelect.value = item.state.select
    }

    onClick(e) {
        const li = e.target.closest('li')
        const Id = li?.getAttribute('Id')
        if (!li || !Id) return
        if (Id === 'create') {
            e.stopPropagation()
            this.createRow()
        }
        else if (Id === 'sort') {
            e.stopPropagation()
            this.sortEvent()
        }
        else if (Id === 'all') this.root.setChartViewArea(this.root.till - this.root.archivestart)
        else if (Id === 'day') this.setDayEvent()
        else {
            const item = this.selectValues.find(item => item.id === Id)
            if (!item) return
            this.select = { id: item.id, value: item.value, update: false, curValue: item.value }
            this.root.setChartViewArea(item.value)
            this.labelElem.innerHTML = dropdownLabelTemplate(getCorrectTime(this.select.curValue))
        }
    }

    onDelete(e) {
        this.selectValues = this.selectValues.filter(item => item.id !== this.selectedRaw.id)
        if (this.selectedRaw.id === this.select.id) {
            this.select = { value: 1000 * 60 * 60 * 24, id: 'day', update: false, curValue: 1000 * 60 * 60 * 24 }
            this.labelElem.innerHTML = dropdownLabelTemplate(getCorrectTime(1000 * 60 * 60 * 24))
            this.root.setChartViewArea(this.select.value)
        }
        this.dropdown.createList()
        this.dropdownContainer.style.display = 'none'
        this._selectedRaw = null
        if (this.root.saveStateFlag) this.saveIntervalState()
    }

    onSelect(e) {
        const elem = this.selectValues.find(item => item.id === this.selectedRaw.id)
        elem.state.select = e.target.value
        const { value, select } = elem.state
        const label = elem.component.querySelector('#value')
        const period = periods()[select]
        elem.value = period.ms * +value
        label.innerHTML = `${value} ${period.label}`
        if (this.selectedRaw.id === this.select.id) {
            this.select = { value: elem.value, id: elem.id, update: false, curValue: elem.value }
            this.root.setChartViewArea(this.select.value)
        }
        if (this.root.saveStateFlag) this.saveIntervalState()
    }

    onInput(e) {
        const elem = this.selectValues.find(item => item.id === this.selectedRaw.id)
        const { select } = elem.state
        elem.state.value = e.target.value
        const period = periods()[select]
        const label = elem.component.querySelector('#value')
        label.innerHTML = `${elem.state.value} ${period.label}`
        elem.value = period.ms * +elem.state.value
        if (this.selectedRaw.id === this.select.id) {
            this.select = { value: elem.value, id: elem.id, update: false, curValue: elem.value }
            this.root.setChartViewArea(this.select.value)
        }
        if (this.root.saveStateFlag) this.saveIntervalState()
    }

    differOnlyInSeconds(timestamp1, timestamp2) {
        const date1 = new Date(timestamp1);
        const date2 = new Date(timestamp2);
    
        return (
            date1.getFullYear() === date2.getFullYear() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getDate() === date2.getDate() &&
            date1.getHours() === date2.getHours() &&
            date1.getMinutes() === date2.getMinutes()
        );
    }

    setDateEvent(elem, v) {
            const value = v
            if(elem === 'start' && !this.differOnlyInSeconds(v, this.startDate)){
                if (value < this.root.msdatazoom.maxvalue){
                    this.root.msdatazoom.updateForDatazoom(value, this.root.msdatazoom.maxvalue)
                } else {
                    if(this.root.archiveend > value){
                        const endValue = value + this.root.interval
                        if(this.root.archiveend > endValue){
                            this.root.msdatazoom.updateForDatazoom(value, endValue)
                        } else {
                                this.root.msdatazoom.updateForDatazoom(value, this.root.archiveend)
                        }
                    } else {
                        this.dpStart.selectDate(this.startDate)
                    }
                }
            }
            if (elem === 'end' && !this.differOnlyInSeconds(v, this.endDate)){
                if(this.root.archiveend > value){
                    if (value > this.root.msdatazoom.minvalue){
                        this.root.msdatazoom.updateForDatazoom(this.root.msdatazoom.minvalue, value)
                    } else {
                        this.root.msdatazoom.updateForDatazoom(value - this.root.interval, value)
                    }
                } else {
                    this.dpEnd.selectDate(this.endDate)
                }
            }
    }

    setDayEvent() {
        const interval = 1000 * 60 * 60 * 24
        this.select = { value: interval, id: 'day', update: false, curValue: interval }
        this.root.setChartViewArea(interval)
    }

    sortEvent() {
        const filtered = this.selectValues
            .filter(item => item.value)
            .sort((a, b) => a.value - b.value)
        this.selectValues.splice(3, filtered.length)
        this.selectValues = this.selectValues.concat(filtered)
    }

    zoomEvent(value) {
        if (!this.root.interval && value) this.select = { value, id: null, update: true, curValue: value }
        this.select.curValue = value
        this.labelElem.innerHTML = dropdownLabelTemplate(getCorrectTime(this.select.curValue))
    }

    toggleDropdown(active) {
        if (active) return
        if (this.dropdownContainer) this.dropdownContainer.style.display = 'none'
    }

    converDataToInput(value) {
        const date = new Date(value)
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}T${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
    }

    get startDate() {
        return this._startDate
    }
    set startDate(v) {
        this._startDate = v
        this.startLabelElem.innerHTML = createDateString(v)
        if(!this.isTimeStartOpen){
            if(this.dpStart) this.dpStart.selectDate(v)
        }
    }

    get endDate() {
        return this._endDate
    }
    set endDate(v) {
        this._endDate = v
        this.endLabelElem.innerHTML = createDateString(v)
        if(!this.isTimeEndOpen){
            if(this.dpEnd) this.dpEnd.selectDate(v)
        }
    }

    get select() {
        return this._select
    }
    set select(v) {
        this._select = v
        const elem = this.selectValues.find(item => item.id === v.id)
        if (!elem) return
        this.labelElem.innerHTML = dropdownLabelTemplate(getCorrectTime(elem.curValue))
        this.root.interval = elem.value
    }

    get selectValues() {
        return this._selectValues
    }
    set selectValues(v) {
        this._selectValues = v
        if (this.dropdown) {
            this.dropdown.values = this._selectValues
            this.dropdown.createList()
        }
    }

    get selectedRaw() {
        return this._selectedRaw
    }
    set selectedRaw(v) {
        if (v.id !== this._selectedRaw?.id) this._selectedRaw = v
    }
}
